<template>

<div class="side-preview animated slideInRight faster" v-if="previewPane.show">
	
    <div class="side-preview-head" v-if="preview">

		<button type="button" class="btn btn-close close" @click="close()" aria-label="Close">
			<span aria-hidden="true">&times;</span>
		</button>

        <div class="car-title">
            <!-- <div class="brand" v-if="preview.model.brand.logo" :style="{backgroundImage:`url(${API_URL+preview.model.brand.logo.urlThumb})`}"></div> -->
            <div class="title">
                <p class="m-0">{{ preview.car.chassis_number }}</p>
                <h2>{{preview.typeText}}</h2>
                <p class="m-0"><small>{{preview.car.brand.title}} - {{preview.car.model}}</small></p>
            </div>
        </div>

	</div>

	<div class="side-preview-content" v-if="preview">
		
		<div class="pill">

			<div class="data pt-2">
                <!-- <h6 class="mt-2">VEHÍCULO</h6>
				<table class="table table-borderless table-sm ">
					<tr>
						<td >Chasis</td> <td>{{preview.car.chassis_number}}</td>
					</tr>
					<tr>
						<td >Motor</td> <td>{{preview.car.motor_number}}</td>
					</tr>
				</table> -->
                
                
				<!-- <div v-if="preview.type=='ADMISSION'">
					<h6 class="mt-3">INGRESO</h6>

					<div class="mt-4" v-if="preview.damages && preview.damages.length>0">

						<div class="alert alert-warning">El vehículo ha sido ingresado con daños y/o faltantes</div>
						<h6>DAÑOS</h6>
						<div class="list-group box-shadow  mt-2">
							<div class="item" v-for="(damage, index) in preview.damages" :key="index" >
								<div class="images" v-if="damage.images.length>0" :style="{backgroundImage: `url('${API_URL+damage.images[0].urlThumb}')` }"></div>
								<div class="info">
									<p>{{damage.type}}</p>
									<h3>{{damage.description}}</h3>
								</div>
							</div>
						</div>
					</div>

					<div class="mt-4" v-if="preview.missings && preview.missings.length>0">
						<h6>FALTANTES</h6>
						<div class="list-group box-shadow mt-2">
							<div class="item pt-1 pb-1" v-for="(missing, index) in preview.missings" :key="index" >
								<div class="info">
									<h3>{{missing.description}}</h3>
								</div>
							</div>
						</div>
					</div>

					<h6 class="mt-3"><small>DATOS CONDUCTOR</small></h6>
					<table class="table table-borderless table-sm mt-3">
						<tr>
							<td >Matricula</td> <td>{{preview.truck_mat}}</td>
						</tr>
						<tr>
							<td >Conductor</td> <td>{{preview.truck_driver_name}}</td>
						</tr>
						<tr>
							<td >Firma</td>
							<td >
								<img :src="preview.truck_driver_signature" class="img-fluid">
							</td>
						</tr>
					</table>
				</div> -->

				<!-- <div v-if="preview.type=='PRE_DELIVERY'">
					<h6 class="mt-3">PRE ENTREGA</h6>
					<table class="table table-borderless table-sm ">
						<tr>
							<td >Lubricantes</td> 
							<td>
								<div class="d-flex justify-content-between mb-1" v-for="lubricant in preview.lubricants" :key="lubricant.id">
									<span>{{lubricant.lubricant.title}}</span>
									<span>{{lubricant.liters}} L</span>
								</div>
							</td>
						</tr>
						<tr>
							<td >Mano de obra</td> <td>{{preview.labor_hours | moment('HH:mm')}} hrs.</td>
						</tr>
						<tr>
							<td >Pulido</td>
							<td >
								<span v-if="preview.polished_pieces==0">Pulido Total</span>
								<span v-if="preview.polished_pieces>0">{{preview.polished_pieces}} Pieza<span v-if="preview.polished_pieces>1">s</span></span>
							</td>
						</tr>
						<tr>
							<td >Carga de gas</td>
							<td >
								<span v-if="preview.gas_charge">SI</span>
								<span v-else>NO</span>
								
							</td>
						</tr>
						<tr>
							<td>Comentarios</td>
							<td >{{preview.comments}}</td>
						</tr>
						
					</table>
				</div> -->

				<div v-if="preview.type=='ADMISSION'">
									
					<div v-if="preview.damages.length>0">
						<h6 class="mt-3">Daños</h6>
						<div class="damage-list">
							<div class="damage"  v-for="damage in preview.damages" :key="damage.id" @click="openDamage(damage,preview.car)">
								<div class="map-content">
									<div class="map" :style="{backgroundImage: `url('${ require('@/assets/img/carsDraws/'+preview.car.category.draw+'/'+damage.side+'.png') }')` }" >
										<div >
											<div class="point animated bounceIn"
												:style="`left:${damage.position.left}%; top:${damage.position.top}%`" 
												:class="[damage.type.toLowerCase()]"
											>
											</div>
										</div>
									</div>
								</div>
								<div class="detail">
									<strong><small>{{damage.typeText}}</small></strong><br>
									{{damage.description}}
								</div>
								<div class="images images-sm">
									<div class="image" v-for="image in damage.images" :key="image.id">
										<div class="background" :style="'background-image:url('+API_URL+image.urlThumb+')'"></div>
									</div>
								</div>
								
							</div>
						</div>
					</div>
					<div v-else>
						<p>Vehículo ingresado sin daños ni faltantes</p>
					</div>
					
					<div v-if="preview.missings.length>0">
						<h6 class="mt-3 mb-2">Faltantes</h6>
						<p class="ml-2" v-for="missing in preview.missings" :key="missing.id">
							<strong>-</strong> {{missing.description}}
						</p>
					</div>

					<div v-if="preview.truck_mat">
						<h6 class="mt-3">Conductor responsable</h6>
						<table class="table table-sm table-labeled-30">
							<tr>
								<td><strong>Matrícula</strong></td>
								<td>{{preview.truck_mat}}</td>
							</tr>
							<tr>
								<td><strong>Conductor</strong></td>
								<td>{{preview.truck_driver_name}}</td>
							</tr>
							<tr>
								<td><strong>Firma</strong></td>
								<td v-if="preview.truck_driver_signature"><img :src="preview.truck_driver_signature" class="img-fluid"></td>
								<td v-else>No se ha podido registrar la firma</td>
							</tr>
						</table>
					</div>
					

				</div>

				<div v-if="preview.type=='PRE_DELIVERY'">
					<table class="table table-sm table-labeled-30">
						<tr>
							<td><strong>Lubricantes</strong></td>
							<td>
								<p v-for="lubricant in preview.lubricants" :key="lubricant.id">
									<strong>-</strong> {{lubricant.lubricant.title}} <strong class="ml-2"> {{lubricant.liters}}L</strong>
								</p>
							</td>
						</tr>
						<!-- <tr>
							<td><strong>Mano de obra</strong></td>
							<td>
								{{preview.labor_hours | moment('HH:mm')}} hrs.
							</td>
						</tr> -->
						<tr>
							<td><strong>Pulido</strong></td>
							<td>
								<span v-if="preview.polished=='total'">Pulido total </span>
								<span v-if="preview.polished=='partial'">Parcial - Se han pulido {{preview.polished_pieces}} piezas</span>
								<span v-if="preview.polished=='none'">No se han pulido piezas</span>
							</td>
						</tr>
						<tr>
							<td><strong>Carga de gas</strong></td>
							<td>
								<span v-if="preview.gas_charge">Si</span>
								<span v-else>No</span>
							</td>
						</tr>
					</table>

					<div class="alert alert-sm mt-2 alert-warning" v-if="preview.has_damages">Se han detectado daños</div>

				</div>

				<div v-if="preview.type=='DELIVERY'">
					
					<div v-if="preview.damages.length>0">
						<h6 class="mt-3">Daños</h6>
						<div class="damage-list">
							<div class="damage"  v-for="damage in preview.damages" :key="damage.id" @click="openDamage(damage,car)" >
								<div class="map-content">
									<div class="map" :style="{backgroundImage: `url('${ require('@/assets/img/carsDraws/'+car.category.draw+'/'+damage.side+'.png') }')` }" >
										<div >
											<div class="point animated bounceIn"
												:style="`left:${damage.position.left}%; top:${damage.position.top}%`" 
												:class="[damage.type.toLowerCase()]"
												:ref="`damage_${damageIndex}`" 
											>
											</div>
										</div>
									</div>
								</div>
								<div class="detail">
									<strong><small>{{damage.typeText}}</small></strong><br>
									{{damage.description}}
								</div>
								<div class="images images-sm">
									<div class="image" v-for="image in damage.images" :key="image.id">
										<div class="background" :style="'background-image:url('+API_URL+image.urlThumb+')'"></div>
									</div>
								</div>
								
							</div>
						</div>
					</div>
					<div v-else>
						<p>Vehículo entregado sin daños ni faltantes</p>
					</div>
					
					<div v-if="preview.missings.length>0">
						<h6 class="mt-3 mb-2">Faltantes</h6>
						<p class="ml-2" v-for="missing in preview.missings" :key="missing.id">
							<strong>-</strong> {{missing.description}}
						</p>
					</div>

					<div v-if="preview.truck_mat">
						<h6 class="mt-3">Entregado a</h6>
						<table class="table table-sm table-labeled-30">
							<tr>
								<td><strong>Matrícula</strong></td>
								<td>{{preview.truck_mat}}</td>
							</tr>
							<tr>
								<td><strong>Conductor</strong></td>
								<td>{{preview.truck_driver_name}}</td>
							</tr>
							<tr>
								<td><strong>Firma</strong></td>
								<td v-if="preview.truck_driver_signature"><img :src="preview.truck_driver_signature" class="img-fluid"></td>
								<td v-else>No se ha podido registrar la firma</td>
							</tr>
						</table>
					</div>
					

				</div>

				<div v-if="preview.type=='CHARGES'">
					<div class="pl-2 mb-2">	
						<div class="" v-for="charge in preview.charges" :key="charge.id">
							<div class="d-flex justify-content-between">
								<p><strong>{{charge.description}}</strong></p>
								<p><strong>U$S {{charge.price}}</strong></p>
							</div>
							<div class="pl-4"><FileList :files="charge.files" size="xs"></FileList></div>
						</div>
					</div>

				</div>

				<div v-if="preview.files.length>0">
					<h6 class="mt-3">Adjuntos</h6>
					<FileList :files="preview.files" size="sm"></FileList>
				</div>

				<div v-if="preview.comments">
					<h6 class="mt-3">Comentarios</h6>
					<p>{{preview.comments}}</p>
				</div>





			</div>
		</div>
	

	</div>

</div>
</template>
	
<script>

import gql from 'graphql-tag'
import FileList from '@/components/FileList'

export default {
	name: 'ControlPreview',
	props:['id'],
	components:{
		FileList
	},
	data () {
		return {
            API_URL: process.env.VUE_APP_API_URL,
			previewPane:{
				show: false,
			},
			preview: {},
		}
	},
	methods:{
		open(id){
			this.preview = {}
			this.previewPane = {
				show: false,
			}
			this.load(id)
		},
		load(id){
			this.$apollo.query({
				query: gql`query ($id: ID!) {
					control(id: $id) {
						user{
							name
						}
						car{
							chassis_number
							model
							brand{
								title
							}
							category{
								draw
							}
						}
						type
						typeText
						lubricants{
							lubricant{
								title
							}
							liters
						}
						labor_hours
						polished
						polished_pieces
						gas_charge
						has_damages
						comments
						files{
							id
							url
							urlThumb
							type
							filename
							extension
						}
						damages{
							side
							images{
								id
								url
								urlThumb
								type
								filename
								extension
							}
							position{
								top
								left
							}
							type
							typeText
							description
							status
						}
						missings{
							description
						}
						truck_mat
						truck_driver_name
						truck_driver_signature
						created_at
					}
				}`,
				variables: {
					id: id,
				},
			})
			.then((data) => {
				this.preview = data.data.control;
				this.previewPane.show = true;
			});
		},
		close(){
			this.previewPane.show = false;
			this.preview = {};
		},
	}
}


</script>

<style scoped lang="scss">
.car-title{
    display:flex;
    align-items: center;
    text-align: left;

    .brand{
        width:64px;
        height: 64px;
        border-radius: 100%;
        background-size: contain;
        background-position: center center;
        background-repeat: no-repeat;
        background-color:#fff;
        margin-right: 8px;
        border: solid #fff 3px;
    }
}

</style>
